export function TableContent({ comerciosKey, comercios }) {
  return (
    <div className="table-comercios--content py-3">
      <div className="table-comercios--content-index">
        <h2>{comerciosKey}</h2>
      </div>
      <div className="table-comercios--content-grid">
        {comercios.map((comercio, index) => (
          <p className="table-comercios--content-element has-xs-font-size" key={index}>{comercio.title}</p>
        ))}
      </div>
    </div>
  )
}